"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexDatesPicker = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FlexDatesPicker = function FlexDatesPicker(_ref) {
  var onChangeShift = _ref.onChangeShift,
      currentShift = _ref.currentShift,
      className = _ref.className;

  if (!_constants.FLEX_DATES.find(function (_ref2) {
    var shiftValue = _ref2.shiftValue;
    return shiftValue === currentShift;
  })) {
    throw new Error('В компонент FlexDatesPicker передана не зарегистрированная флексовая дата');
  }

  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, _constants.FLEX_DATES.map(function (_ref3) {
    var title = _ref3.title,
        shiftValue = _ref3.shiftValue;
    return /*#__PURE__*/_react["default"].createElement(Button, {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        onChangeShift(shiftValue);
      },
      key: shiftValue,
      $isActive: shiftValue === currentShift
    }, title);
  }));
};

exports.FlexDatesPicker = FlexDatesPicker;

var Container = _styledComponents["default"].span.withConfig({
  displayName: "FlexDatesPicker__Container",
  componentId: "sc-132c5zo-0"
})(["box-sizing:border-box;display:flex;justify-content:space-between;height:44px;padding:2px;background:#f3f3f3;border-radius:10px;align-items:center;max-width:270px;width:100%;"]);

var Button = _styledComponents["default"].button.withConfig({
  displayName: "FlexDatesPicker__Button",
  componentId: "sc-132c5zo-1"
})(["color:var(--black);padding:12px;height:100%;border-radius:var(--border-radius);border:0;", " text-align:center;font-size:14px;font-weight:400;line-height:14px;cursor:pointer;"], function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive ? (0, _styledComponents.css)(["background-color:var(--white);color:var(--secondary-header);font-weight:500 !important;"]) : (0, _styledComponents.css)(["background-color:var(--background);color:var(--black);"]);
});